<button class="categoria-card" (click)="click.emit($event)">
  <header>
    <p class="description">
      {{ description }}
    </p>

    <h2 class="categoria">
      {{ title }}
    </h2>
  </header>

  <div class="content">
    <img [src]="image" />
  </div>
</button>